import React, { useEffect, useState, useId } from 'react'
import { v4 as uuid } from 'uuid';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux'
import { setMatchingPairsFlip, addMatchingPairsPair, updateDescription } from '../../../../redux/slices/userActivity';
import { shuffle } from '../../../../utils';
import Card from "./Pair/card";
import Pair from './Pair/pair'
import './style.css'

export default function MatchingPairs({ question_id }) {
   
   const maxPairs = 8

   let { matchingpair_set } = question_id
   const [activeIndex, setActiveIndex] = useState(0)
   const { modalOpen: previewModalOpen, showAnswers } = useSelector(state => state.preview)
   const [playingCards, setPlayingCards] = useState([])
   const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
   const [nextBtnDisabled, setNextBtnDisabled] = useState(false)
   const unique_id = uuid();

   useEffect(() => {
      activeIndex === 0 ? setPrevBtnDisabled(true) : setPrevBtnDisabled(false)
      activeIndex === matchingpair_set.length ? setNextBtnDisabled(true) : setNextBtnDisabled(false)
      activeIndex === maxPairs - 1 && setNextBtnDisabled(true)
      // : setNextBtnDisabled(false)
   }, [activeIndex, matchingpair_set.length])
   const dispatch = useDispatch()

   useEffect(() => {
      if(matchingpair_set !== undefined){
         dispatch(setMatchingPairsFlip())
      }
   }, [])

   useEffect(() => {
      let tempCards = playingCards.map(card => ({ ...card, isFlipped: showAnswers }))
      setPlayingCards(tempCards)
   }, [showAnswers])

   let pair = {
      // id: matchingpair_set[matchingpair_set.length - 1].id + 1,
      id: Math.floor(Math.random() * 1000000000),
      created_at: '2022-07-23T10:55:45.863269Z',
      updated_at: '2022-07-23T10:55:45.863288Z',
      l_option: 'Text 1',
      r_option: 'Text 2',
      l_image: null,
      l_image_url: null,
      r_image: null,
      r_image_url: null,
      l_audio: null,
      r_audio: null,
      // matching_pair_head_id: matchingpair_set,
      l_flipped: false,
      r_flipped: false
   }

   useEffect(() => {
      if (previewModalOpen === false) return
      let playingCards = []
      matchingpair_set.map(({ l_option, r_option, l_image, r_image, l_image_data, r_image_data }) => {
         console.log(matchingpair_set)
         playingCards.push(
            {
               isLeft: true,
               isFlipped: false,
               option: l_option,
               image: l_image_data,
               default_image_url: l_image
            },
            {
               isLeft: true,
               isFlipped: false,
               option: r_option,
               image: r_image_data,
               default_image_url: r_image
            }
         )
      })
      setPlayingCards(shuffle(playingCards))
   }, [previewModalOpen])

   const addPair = () => {
      if (matchingpair_set.length === 8) return
      dispatch(addMatchingPairsPair({ pair }))
   }

   //to change pair slides
   const add = () => {
      if (activeIndex === matchingpair_set.length) return
      setActiveIndex(activeIndex + 1)
   }

   const previous = () => {
      if (activeIndex === 0) return
      setActiveIndex(activeIndex - 1)
   }

   const onDescriptionChange = e => {
      let description = e.target.value
      if (e.target.value.length > 100) return
      dispatch(updateDescription({ description }))
   }

   return (

      !previewModalOpen ? (
         <>
            <div className={'matching-pairs'} >
               <p className='header' > Add text or image for minimum 3 pairs to create a Matching Pairs game: </p >

               <div className='cards-container'>
                  <div className='pairs-wrapper'>
                     {matchingpair_set.map((pair, idx) => {
                        return (
                           <div key={idx} className='pair'
                              id={idx === activeIndex ? 'active' : idx === activeIndex - 1 ? 'previous' : idx === activeIndex + 1 ? 'next' : 'in-active'}>
                              <Pair {...pair} idx={idx} addPair={addPair} matchingpair_set={matchingpair_set} />
                           </div>
                        )
                     })}
                     {
                        matchingpair_set.length < maxPairs &&
                        <div className='pair dummy'
                           id={activeIndex === matchingpair_set.length - 1 ? 'visible' : activeIndex === matchingpair_set.length ? 'active' : ''}>
                           <Pair pair={pair} isDummy={true} addPair={addPair} />
                        </div>
                     }
                  </div>
               </div>
               <div className='buttons'>
                  <button className='btn-left' onClick={previous} disabled={prevBtnDisabled} >
                     &lt;  previous
                  </button>
                  <button onClick={add} disabled={nextBtnDisabled} >
                     next  &gt;
                  </button>
               </div>
               <div className='description-container'>
                  <label>Add short description: (optional)</label>
                  <textarea onChange={e => onDescriptionChange(e)} value={question_id.description} placeholder='Among the following set of cards are 6 famous company logos and names. Find the matching pairs.'>
                  </textarea>
               </div>
               {/* <div className='background' ></div> */}
            </div >
         </>
      ) :
         (
            <div className='matching-pairs-preview matching-pairs'>
               <p className='header'>Find the matching pairs: </p >
               <div className='box'>
                  <div className='cards-container'>
                     {playingCards.map((card, idx) => {
                        return (
                           <Card key={idx} {...card} />
                        )
                     })}
                  </div>
                  {/* <div>
                     <button>
                        show answers
                     </button>
                  </div> */}
               </div>
            </div>
         )

   )
}
